export default __webpack_public_path__ + "static/media/7.73589a3d.jpg";